module.exports = __webpack_public_path__ + "static/img/7.9e6ef6c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/9/sp/7.png
// module id = itoY
// module chunks = 0